// extracted by mini-css-extract-plugin
module.exports = {"reminder":"Reminder_mobile_reminder__PALxz","svg":"Reminder_mobile_svg__DGULo","link":"Reminder_mobile_link__qFMcP"};